<template>
  <!-- <AddButton v-if="showButton" @click="IsCreate()" :btnname=" $t('btn.plusaddnew')" />
    <EditIcon class="" v-if="!showButton" @click="IsEdit()" /> -->

  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="model ? $t('otherterms.Edittitle') : $t('otherterms.title')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <!-- <Loader :loading="loading" /> -->
    <div>
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <b-col lg="6" md="6" sm="6" cols="12">
            <div class="field">
              <TextField
                v-model="insert_data.OtherTermCode"
                type="text"
                :label="$t('otherterms.code')"
                clearable
                disabled
                name="Code"
                id="Code"
                :rules="{ required: true, alphanumeric: true }"
                :required-icon="true"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="field">
              <Textarea
                v-model="insert_data.OtherTermDesc"
                type="text"
                :label="$t('otherterms.remark')"
                name="Remarks"
                id="Remarks"
                :rules="{ required: false }"
                :required-icon="false"
                :autofocus="true"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <Footer
              @cancel="IsClear()"
              :cancelhide="false"
              :label="label"
              :loading="Saveloading"
            />
          </b-col>
        </b-row>
      </b-form>
    </div>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/OtherTermsService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import Textarea from "../../../../../../components/FormComponents/TextArea.vue";

import common from "../../../../Service/CommonService";
import { useRoute } from "vue-router";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
  },

  components: {
    Footer,
    axios,
    useRoute,
    TextField,
    Textarea,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
  },

  setup(props, { emit }) {
    debugger;
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const showDialog = ref(false);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      event.preventDefault;
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    const insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      OtherTermDesc: "",
      OtherTermCode: "",
      EntityId: 0,
      EntityOperationId: 0,
    });

    //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      showDialog.value = false;
      //emit("update:trigger", false);
      emit("update:selectedItem", undefined);
      emit("close");
    }

    // Add New PopUp
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    async function GetCode() {
      debugger;
      let data = {
        // FormId: 13,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      insert_data.value.OtherTermCode = result;
    }

    //Row Edit
    async function IsEdit() {
      showDialog.value = true;
      // loading.value = true;
      emit("loadershow");
      debugger;
      try {
        label.value = t("btn.update");
        const EditId = model.value.Id;
        const response = await service.Edit(EditId);
        const data = response["result"];
        console.log(response["result"]);

        Object.keys(insert_data.value).forEach((key) => {
          if (data[key]) insert_data.value[key] = data[key];
        });
        // loading.value = false;
        emit("loaderhide");
      } catch (error) {
        // loading.value = false;
        emit("loaderhide");
        alert(error);
      }
    }

    //Save
    const IsSubmit = async () => {
      Saveloading.value = true;
      emit("loadershow");

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      debugger;
      insert_data.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      insert_data.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      insert_data.value.BranchId = 0;
      insert_data.value.HospitalId = HospitalId;
      insert_data.value.ModifiedBy = UserId;
      insert_data.value.CreatedBy = UserId;
      insert_data.value.EntityId = Number(Entitydata.value.EntityId);

      let objinsert = Object.assign(insert_data.value);
      console.log(objinsert);
      try {
        let msg = "";
        if (insert_data.value.Id != 0) {
          insert_data.value.EntityOperationId = props.OperationID.UpdateId;
          const data_response = await service.Update(insert_data.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (msg == null && data_response["result"] == "Already") {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          insert_data.value.EntityOperationId = props.OperationID.CreateId;
          const data_response = await service.insert(insert_data.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (msg == null && data_response["result"] == "Already") {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        alert(error);
      }
    };

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      insert_data.value.OtherTermDesc = "";
    }

    return {
      model,
      showModal: ref(false),
      insert_data,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,

      successpop,
      updatepop,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
      Saveloading,
    };
  },
});
</script>
